import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function Skills() {
    const {data :{home: {skills : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="container-xxl py-5" id="skill">
            <div className="container">
                <div className="row g-5">
                    {data.lso_skills && data.lso_skills.map((row,index) => 
                    <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s" key={index}>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center justify-content-center bg-light" style={{width: "60px", height: "60px"}}>
                                <i className={`${row.ico_icon} fa-2x text-primary`}></i>
                            </div>
                            <h1 className="display-1 text-light mb-0">0{index+1}</h1>
                        </div>
                        <h5>{row.txt_title}</h5>
                    </div>)}
                </div>
            </div>
        </div>
     );
}

export default Skills;